import React from "react";
import blogImg from "../assets/images/blogImg.png";

export default function ProjectItem({
  img = blogImg,
  title = "Project Name",
  desc = "lorem lorem lorem lorem lorem lorem lorem lorem lorem lorem ",
  href
}) {
  return (
    <div className="projectItem__wrapper">
      <a href={href} className="projectItem__img">
        <img src={img} alt="project img" />
      </a>
      <div className="projectItem__info">
        <a href={href}>
          <h3 className="projectItem__title">{title}</h3>
        </a>
        <p className="projectItem__desc">{desc}</p>
      </div>
    </div>
  );
}
